import * as React from 'react';

export const PeopleColumnsMenu = ({
  columns,
  hidden,
  onChange
}: {
  columns: Array<{ key: string; label: string }>;
  hidden: string[];
  onChange: (hidden: string[]) => void;
}) => {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const close = (event: MouseEvent) => ref.current && !ref.current.contains(event.target as Node) && setOpen(false);
    const closeOnEscape = (event: KeyboardEvent) => event.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);
  return (
    <div className="people-columns" ref={ref}>
      <button
        type="button"
        className="people-btn people-btn--secondary people-btn--iconLeft"
        onClick={() => setOpen(!open)}
      >
        <span className="people-icon people-icon--columns" />
        Columns <span className="people-btn__badge">{columns.length - hidden.length}</span>
      </button>
      {open && (
        <div className="people-columns__menu">
          <div className="people-columns__head">
            <span>Show / hide columns</span>
            <button type="button" onClick={() => onChange([])}>
              Reset
            </button>
          </div>
          {columns.map(column => (
            <label className="people-columns__item" key={column.key}>
              <input
                type="checkbox"
                checked={!hidden.includes(column.key)}
                onChange={() =>
                  onChange(
                    hidden.includes(column.key) ? hidden.filter(key => key !== column.key) : [...hidden, column.key]
                  )
                }
              />
              <span>{column.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
